import * as types from "../actions/types";


const initialState = {

};


export default function datasets(state = initialState, action) {
  switch (action.type) {

    case types.SET_DATASETS_LIST:
      return {
        ...state,
        datasetsList: action.payload
      };
    case types.SET_DATASETS_ALL_LIST:
      return {
        ...state,
        datasetsAllList: action.payload
      };
    case types.SET_FIELD_ALL_LIST:
      return {
        ...state,
        fieldAllList: action.payload
      };
    case types.SET_FIELDS:
      return {
        ...state,
        fields: action.payload
      };

    case types.SET_DASHBOARD_SERVERS:
      return {
        ...state,
        servers: action.payload
      };

    case types.SET_DASHBOARD_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    default:
      return state;
  }
}